import { render, staticRenderFns } from "./COAAddGroupModal.vue?vue&type=template&id=50af5827&scoped=true&"
import script from "./COAAddGroupModal.vue?vue&type=script&lang=js&"
export * from "./COAAddGroupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50af5827",
  null
  
)

export default component.exports